import IsAuthenticatedModel from '@components/Share/FooterNavigation/model/IsAuthenticatedModel';
import SitecoreImageModel from '@models/SitecoreImageModel';
import SitecoreLinkModel from '@models/SitecoreLinkModel';
import SitecoreTextModel from '@models/SitecoreTextModel';

export default class IconNavigationFieldsModel {
  constructor() {
    this.Link = new SitecoreLinkModel();

    this.Title = new SitecoreTextModel();

    this.Image = new SitecoreImageModel();

    this['Is Authenticated'] = new IsAuthenticatedModel();
  }

  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Link')) {
      this.Link.getData(dataSource.Link);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Title')) {
      this.Title.getData(dataSource.Title);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Image')) {
      this.Image.getData(dataSource.Image);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Is Authenticated')) {
      this['Is Authenticated'].getData(dataSource['Is Authenticated']);
    }

    return this;
  }
}
